import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  open: false,
  activeTab: null,
  navItems: []
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setNavItems: (state, action) => {
      state.navItems = action.payload;
    },
    toggleMenu: (state) => {
      state.open = !state.open;
    },
    openMenu: (state) => {
      state.open = true;
    },
    closeMenu: (state) => {
      state.open = false;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
      state.open = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const { toggleMenu, openMenu, closeMenu, setActiveTab, setLoading, setNavItems } =
  menuSlice.actions;

export default menuSlice.reducer;
